import React from 'react';
import { motion } from 'framer-motion';
import { logoVariants } from './animations';

/** HAAT logo URL */
const LOGO_URL = 'https://cdn.prod.website-files.com/6829acf870093a50cc6ceb69/682b03419ead6e45d8f2c59e_logo%20(2).svg';

/**
 * LoginLogo Component
 * 
 * Displays the HAAT Hub logo with welcome text.
 * Animated on page load.
 * 
 * @example
 * <LoginLogo />
 */
const LoginLogo: React.FC = () => {
  return (
    <motion.div
      variants={logoVariants}
      initial="initial"
      animate="animate"
      className="text-center mb-12"
    >
      <div className="inline-flex items-center justify-center w-20 h-20">
        <img
          src={LOGO_URL}
          alt="HAAT Hub Logo"
          className="w-full h-full object-contain"
          loading="eager" // Important for LCP (Largest Contentful Paint)
        />
      </div>
      <h1 className="text-3xl font-rubik font-bold text-haat-dark mb-2">
        Welcome to HAAT Hub
      </h1>
      <p className="text-haat-gray font-inter">
        Enterprise Portal
      </p>
    </motion.div>
  );
};

export default LoginLogo;

